import React from "react";
import T from "prop-types";
import { shortDate } from "LIB/formatters/date";
import Delete from "MODULES/shared/components/Delete";
import { NoteTooltipTableCell } from "MODULES/shared/components/NoteTooltip";
import { CONDITION_TYPES } from "./constants";
import EditDummy from "./EditDummy";
import * as actions from "../../../actions";

export default class Table extends React.Component {
  state = {
    editDummyModalOpen: false
  };

  openEditDummyModal = () => this.setState({ editDummyModalOpen: true });

  closeEditDummyModal = () => this.setState({ editDummyModalOpen: false });

  render() {
    const { editDummyModalOpen } = this.state;
    const { dummy } = this.props;

    return (
      <div>
        <h2 style={{ marginTop: 26 }}>Dummy Stock</h2>
        <table className="table table-striped table-hover margin-bottom-none">
          <thead>
            <tr>
              <th>Condition</th>
              <th>Quantity</th>
              <th>Created At</th>
              <th>Created By</th>
              <th>Updated At</th>
              <th>Updated By</th>
              <th />
              <th />
            </tr>
          </thead>
          <tbody>
            <tr className="clickable" onClick={this.openEditDummyModal}>
              <td>{CONDITION_TYPES[dummy.condition].label}</td>
              <td>{dummy.quantity}</td>
              <td>{shortDate(dummy.created_at)}</td>
              <td>{dummy.created_by && dummy.created_by.full_name}</td>
              <td>{shortDate(dummy.updated_at)}</td>
              <td>{dummy.updated_by && dummy.updated_by.full_name}</td>
              <NoteTooltipTableCell note={dummy.note} />
              <Delete
                primary={false}
                id={dummy.id}
                deleteAction={actions.destroyDummy}
              />
            </tr>
          </tbody>
        </table>
        <EditDummy
          dummy={dummy}
          open={editDummyModalOpen}
          close={this.closeEditDummyModal}
        />
      </div>
    );
  }
}

Table.propTypes = {
  dummy: T.shape({
    id: T.number.isRequired,
    condition: T.string.isRequired,
    quantity: T.number.isRequired,
    note: T.string,
    created_at: T.string.isRequired,
    updated_at: T.string.isRequired,
    created_by: T.shape({
      full_name: T.string
    }),
    updated_by: T.shape({
      full_name: T.string
    })
  }).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Dummies/Table.jsx